import React, {Component} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import "./MakeDialog.css";

export class MakeDialog extends Component {
  constructor(props) {
    super(props);
    let isOpen = false;
    if (this.props.isOpen !== true || this.props.isOpen !== false) isOpen = this.props.isOpen;
    this.state = {
      isOpen: isOpen
    }
  }

  render() {
    let isOpen = this.state.isOpen;
    if (this.props.isOpen !== true || this.props.isOpen !== false) isOpen = this.props.isOpen;
    return (
      <Modal isOpen={isOpen}
             className={`${this.props.size || 'modal-lg'} ` + (this.props.className || "")}>
        {(this.props.hideHeader === undefined || this.props.hideHeader === false) && (
          <ModalHeader tag={this.props.headerTag || "h4"}
                       className={"modal-header"}
                       cssModule={{width: "100%"}}>{this.props.header || "Add header prop"}</ModalHeader>
        )}

        <ModalBody>
          {this.props.children}
        </ModalBody>
        {(this.props.hideFooter === undefined || this.props.hideFooter === false) && (
          <ModalFooter>
            {this.props.footer || this.props.children['props']['footer'] || (
              <Button color="secondary"
                      onClick={() => this.setState({isOpen: false})}>Close</Button>
            )}
          </ModalFooter>
        )}
      </Modal>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/Shared/MakeDialog.js